var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 420 489.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.5,69.9c-97.3,0-180.8-65.4-181.6-66.1C217.8,1.3,213.9,0,210,0s-7.8,1.3-10.9,3.8c-0.9,0.7-84,66.1-181.6,66.1 c-4.6,0-9.1,1.8-12.4,5.1S0,82.8,0,87.4v157.5c0,117.4,47.4,175,202.8,243.4c4.6,2.1,9.8,2.1,14.4,0 C372.6,419.9,420,362.3,420,244.9V87.4c0-4.6-1.8-9.1-5.1-12.4S407.1,69.9,402.5,69.9L402.5,69.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldIcon);
export default __webpack_public_path__ + "static/media/shield-icon.25562d7cdcdd6ac94522663b016001a3.svg";
export { ForwardRef as ReactComponent };